import { Component, Input } from '@angular/core';

@Component({
    selector: 'accessibility-table-filter-selector-item-template',
    template: `
        <span class="fa-width-6x text-center" *ngIf="['review', 'error', 'warning', 'mobile'].indexOf(item.value) > -1">
            <span class="fa-lg" [ngClass]="['ACCESSIBILITY', 'ISSUES_CHECKS', 'REVIEW'] | monIcons" *ngIf="item.value === 'review'"></span>
            <span class="fa-lg" [ngClass]="['ACCESSIBILITY', 'ISSUES_CHECKS', 'ERROR'] | monIcons" *ngIf="item.value === 'error'"></span>
            <span class="fa-lg" [ngClass]="['ACCESSIBILITY', 'ISSUES_CHECKS', 'WARNING'] | monIcons" *ngIf="item.value === 'warning'"></span>
            <span class="fa-lg" [ngClass]="['ACCESSIBILITY', 'ISSUES_CHECKS', 'MOBILE'] | monIcons" *ngIf="item.value === 'mobile'"></span>
        </span>
        {{item.name}}
    `,
    standalone: false,
})
export class AccessibilityTableFilterSelectorItemTemplateComponent {
    @Input({ required: true }) item!: FilterItem;
}


type FilterItem = {
    value: string;
    name: string;
};
